import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import swal from 'sweetalert2'

@Injectable()
export class AuthService {

  authSubject = new Subject<any>();
  auth$ = this.authSubject.asObservable();

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth) { }

  login(email: string, password: string): void {
    this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then(user => {
        this.router.navigate(['/']);
      })
      .catch(error => {
        console.error(error);
        let errorCode = error.code;
        let errorMessage = error.message;
        if (errorCode == 'auth/user-not-found') {
          swal({
            title: 'ログイン失敗',
            text: '指定された電子メールアドレスは登録されていません。',
            type: 'error',
            confirmButtonText: 'OK'
          })
        } else if(errorCode == 'auth/wrong-password') {
          swal({
            title: 'ログイン失敗',
            text: 'パスワードが違います。',
            type: 'error',
            confirmButtonText: 'OK'
          })
        } else if(errorCode == 'auth/invalid-email') {
          swal({
            title: 'ログイン失敗',
            text: '指定された電子メールアドレスは有効ではありません。',
            type: 'error',
            confirmButtonText: 'OK'
          })
        } else {
          swal({
            title: 'ログイン失敗',
            text: errorMessage,
            type: 'error',
            confirmButtonText: 'OK'
          })
        }
      });
  }

  logout(): void {
    this.afAuth.auth.signOut()
      .then(() => {
        this.router.navigate(['/']);
      })
      .catch(error => console.error(error));
  }

  message(): void {
    this.afAuth.authState.subscribe((user) => {
      if (!user) {
        swal({
          title: 'ログインしてください',
          text: 'ユーザー情報が確認できません。',
          type: 'error',
          confirmButtonText: 'OK',
        })
        this.router.navigate(['/login']);
      } 
    });
  }

}


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/core/service/auth.service.ts